const collapse = () => {
    const toggleSwitches = $('.js--collapse__toggle');
    const textShowMore = $('html').attr('lang') === 'uk-ua' ? 'Показати далі' : 'Показать далее';
    const textHideMore = $('html').attr('lang') === 'uk-ua' ? 'Сховати' : 'Скрыть';

    toggleSwitches.each(function () {
        $(this).on('click', (e) => {
            e.preventDefault();

            $(this).prev('.js--collapse').toggle();
            if ($(this).prev('.js--collapse').css('display') === 'none') {
                $(this).html(textShowMore);
            } else {
                $(this).html(textHideMore);
            }
        });
    });
};

export default collapse;
